import { render, staticRenderFns } from "./char.vue?vue&type=template&id=86d5ed32&scoped=true&"
import script from "./char.vue?vue&type=script&lang=js&"
export * from "./char.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d5ed32",
  null
  
)

export default component.exports